import React, {useEffect, useState} from 'react';
import {Outlet, useParams} from "react-router-dom";
import {useError} from "../../hooks/useError";
import {getProductByName, getProductTokenByProductName} from "../../services/ProductRepository";
import {setProductName} from "../../services/AxiosConfig";


export function ProductLayout() {
    const [product, setProduct] = useState(null);
    const [token, setToken] = useState(null);
    const params = useParams();
    const {setErrorMessage} = useError();

    useEffect(() => {
        getProductTokenByProductName(params.productName, setErrorMessage).then(result => {
            setProductName(params.productName)
            setProduct(result.token.product)
            setToken(result.token)
        }).catch(err => {
            console.error(err)
        });
    }, []);

    if(product != null) {
        return (
            <>
                <Outlet context={{
                    product: product,
                    courseId: product.courseCode,
                    token: token
                }}/>
            </>
        );

    }

}